import { render, staticRenderFns } from "./GamesHeader.vue?vue&type=template&id=78f1b8bc"
import script from "./GamesHeader.vue?vue&type=script&lang=js"
export * from "./GamesHeader.vue?vue&type=script&lang=js"
import style0 from "./GamesHeader.vue?vue&type=style&index=0&id=78f1b8bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports